import React from 'react'

const ReviewTerms = () => {
  return (
    <div className='review-terms'>
      <p className='review-terms-text'>
        By submitting this review, you agree to our
        <a
          href='https://judge.me/terms'
          target='_blank'
          rel='noopener noreferrer'
          className='review-terms-link'
        >
          {' '}
          Terms & Conditions
        </a>
        . Your review may be published on our website and used for marketing purposes.
        We will never share your email address.
      </p>
    </div>
  )
}

export default ReviewTerms
